import React, { forwardRef } from 'react';
import { areEqual, FixedSizeList, ListChildComponentProps } from 'react-window';
import { useRecoilValue } from 'recoil';
import { useOpenPopup } from 'src/modules/imagesV3/hooks/useOpenPopup';
import {
  materialItemSelector,
  myMaterialsListSelector
} from 'src/modules/imagesV3/store/selector';
import EmptyPlaceholder from '../../EmptyPlaceholder';

import ImageButton from '../../ImageButton';
import BaseListItem from '../BaseListItem';
import { LIST_HEIGHT, RATIO, LIST_WIDTH } from '../list';
import styles from './index.module.scss';

const calcStyle = (style: any) => {
  return {
    ...style,
    top: `${parseFloat(style.top) + 10 * RATIO}px`
  };
};

const Row = React.memo(
  ({ index, style, data }: ListChildComponentProps<number[]>) => {
    const item = useRecoilValue(materialItemSelector(data[index]));
    const openPopup = useOpenPopup();
    if (!item) return null;
    const getId = () => {
      if (item.toolId > 0) return item.toolId;
      if (!item.specialExtend) return item.toolId;
      return 987654320 + (item.specialExtend.piecesType || 0);
    };
    const placeholder = (() => {
      if (
        item.type === 0 &&
        item.specialExtend?.piecesType &&
        item.specialExtend.piecesType > 0
      ) {
        //宝石没有按钮时默认显示无法打磨
        return '数量不足10个，无法打磨';
      }
      //其他材料默认不可转赠
      return '不可转赠';
    })();
    return (
      <div className={styles.wrapper} style={calcStyle(style)}>
        <BaseListItem
          logo={item.logo}
          title={item.title}
          desc={item.desc}
          count={item.number}
          placeholder={placeholder}
          buttons={[
            item.canSend && (
              <ImageButton
                type="primary"
                onClick={() => openPopup('present', getId())}
              >
                赠送
              </ImageButton>
            ),
            item.specialExtend && item.specialExtend.canPolish && (
              <ImageButton
                type="primary"
                onClick={() => openPopup('polish', getId())}
              >
                打磨
              </ImageButton>
            ),
            item.type === 1 && (
              <ImageButton
                type="primary"
                onClick={() => openPopup('transform', getId())}
              >
                转换
              </ImageButton>
            ),
            item.specialExtend && item.specialExtend.canCompose && (
              <ImageButton
                type="primary"
                onClick={() => openPopup('compose', getId())}
              >
                合成
              </ImageButton>
            )
          ]}
        />
      </div>
    );
  },
  areEqual
);

const InnerElementType: React.FC = forwardRef<any, any>(
  ({ style, ...rest }, ref) => (
    <div
      ref={ref}
      style={{
        ...style,
        height: `${parseFloat(style.height) + 30 * RATIO}px`
      }}
      {...rest}
    />
  )
);

const MyMaterialsList: React.FC = () => {
  const list = useRecoilValue(myMaterialsListSelector);
  if (list.length === 0) return <EmptyPlaceholder />;
  return (
    <FixedSizeList
      height={LIST_HEIGHT}
      itemCount={list.length}
      itemData={list}
      itemSize={280 * RATIO}
      width={LIST_WIDTH}
      className={styles.container}
      innerElementType={InnerElementType}
    >
      {Row}
    </FixedSizeList>
  );
};

export default React.memo(MyMaterialsList);
